import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ViaCepResponse } from '../interfaces/viaCep';
import { environment } from '../../environments/environment';
import { HtmlService } from './htmlservice';

@Injectable({
  providedIn: 'root'
})
export class ExternalService {

  private baseUrl = environment.baseUrl;
  private urlViaCep = this.baseUrl + "/api/External/ViaCep";

  constructor(private http: HttpClient, private htmlService: HtmlService) { }

  getCep(cep: string): Observable<ViaCepResponse>{

    const headers = this.htmlService.getHeaders();
    const result = this.http.get<ViaCepResponse>(`${this.urlViaCep}/${cep}`, {headers});
    return result;
  }
}
